import HealthcheckList from './HealthcheckList';
import HealthcheckCreate from './HealthcheckCreate';

export default {
  list: HealthcheckList,
  create: HealthcheckCreate,
  edit: HealthcheckCreate,
}
